// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/builds/litta-front/litta-palmer/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/pageLoading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__index' */'@/layouts/index.jsx'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/403",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__403' */'@/pages/403.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/404",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/ActionForbidModel/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActionForbidModel__detail' */'@/pages/ActionForbidModel/detail.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/ActionForbidModel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ActionForbidModel__index' */'@/pages/ActionForbidModel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/customAction/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__customAction__detail__index' */'@/pages/action/customAction/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/customAction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__customAction__index' */'@/pages/action/customAction/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/exclusivePlan/course",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__exclusivePlan__course' */'@/pages/action/exclusivePlan/course.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/exclusivePlan/cycle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__exclusivePlan__cycle' */'@/pages/action/exclusivePlan/cycle.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/exclusivePlan",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__exclusivePlan__index' */'@/pages/action/exclusivePlan/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/exclusiveProgram/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__exclusiveProgram__detail__index' */'@/pages/action/exclusiveProgram/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/exclusiveProgram",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__exclusiveProgram__index' */'@/pages/action/exclusiveProgram/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/featureCourse/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__featureCourse__detail__index' */'@/pages/action/featureCourse/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/featureCourse",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__featureCourse__index' */'@/pages/action/featureCourse/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/list/addAction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__list__addAction__index' */'@/pages/action/list/addAction/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/list/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__list__detail__index' */'@/pages/action/list/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/list/editAction",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__list__editAction__index' */'@/pages/action/list/editAction/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__list__index' */'@/pages/action/list/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/list/problem",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__list__problem__index' */'@/pages/action/list/problem/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/planKnowledge",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__planKnowledge__index' */'@/pages/action/planKnowledge/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/posture",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__posture__index' */'@/pages/action/posture/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/selfWrittenCourses/course",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__selfWrittenCourses__course' */'@/pages/action/selfWrittenCourses/course.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/selfWrittenCourses",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__selfWrittenCourses__index' */'@/pages/action/selfWrittenCourses/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/action/user",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__action__user__index' */'@/pages/action/user/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/actionEvaluateStandard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__actionEvaluateStandard__index' */'@/pages/actionEvaluateStandard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/ActionOverviewDialog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__ActionOverviewDialog' */'@/pages/activity/vitalityGo/ActionOverviewDialog.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/AgreementPlaybackDialog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__AgreementPlaybackDialog' */'@/pages/activity/vitalityGo/AgreementPlaybackDialog.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/DailyActivityDialog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__DailyActivityDialog' */'@/pages/activity/vitalityGo/DailyActivityDialog.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/DailyActivityDialogDemo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__DailyActivityDialogDemo' */'@/pages/activity/vitalityGo/DailyActivityDialogDemo.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/FitTrackMap",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__FitTrackMap' */'@/pages/activity/vitalityGo/FitTrackMap.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/KeypointPlayer",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__KeypointPlayer' */'@/pages/activity/vitalityGo/KeypointPlayer.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/ProgressBar",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__ProgressBar' */'@/pages/activity/vitalityGo/ProgressBar.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/StoreDetailDialog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__StoreDetailDialog' */'@/pages/activity/vitalityGo/StoreDetailDialog.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__detail' */'@/pages/activity/vitalityGo/detail.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/detailBackup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__detailBackup' */'@/pages/activity/vitalityGo/detailBackup.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo/detailDemo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__detailDemo' */'@/pages/activity/vitalityGo/detailDemo.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/activity/vitalityGo",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__activity__vitalityGo__index' */'@/pages/activity/vitalityGo/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/ModalVideoVisual",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__ModalVideoVisual__index' */'@/pages/aiWorkManager/ModalVideoVisual/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/actionManager/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__actionManager__detail__index' */'@/pages/aiWorkManager/actionManager/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/actionManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__actionManager__index' */'@/pages/aiWorkManager/actionManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/formulaManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__formulaManager__index' */'@/pages/aiWorkManager/formulaManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/modelMark/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__modelMark__edit__index' */'@/pages/aiWorkManager/modelMark/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/modelMark",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__modelMark__index' */'@/pages/aiWorkManager/modelMark/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/aiWorkManager/modelMark/mark",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__aiWorkManager__modelMark__mark__index' */'@/pages/aiWorkManager/modelMark/mark/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/communityManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__communityManagement__index' */'@/pages/athena/communityManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/hotCoachMap",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__hotCoachMap__index' */'@/pages/athena/hotCoachMap/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__detail__index' */'@/pages/athena/merchantProfile/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__index' */'@/pages/athena/merchantProfile/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/shell/HeaderActions",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__shell__HeaderActions' */'@/pages/athena/merchantProfile/shell/HeaderActions.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/shell/MerchantHeader",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__shell__MerchantHeader' */'@/pages/athena/merchantProfile/shell/MerchantHeader.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/MemberTab",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__MemberTab' */'@/pages/athena/merchantProfile/tabs/MemberTab.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/ProfileTab",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__ProfileTab' */'@/pages/athena/merchantProfile/tabs/ProfileTab.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/UserTab",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__UserTab' */'@/pages/athena/merchantProfile/tabs/UserTab.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/BoardTab",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__BoardTab' */'@/pages/athena/merchantProfile/tabs/board/BoardTab.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/MemberOps",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__MemberOps' */'@/pages/athena/merchantProfile/tabs/board/MemberOps.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/ServiceDelivery",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__ServiceDelivery' */'@/pages/athena/merchantProfile/tabs/board/ServiceDelivery.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/StoreOps",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__StoreOps' */'@/pages/athena/merchantProfile/tabs/board/StoreOps.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/TradeOps",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__TradeOps' */'@/pages/athena/merchantProfile/tabs/board/TradeOps.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/WeekReport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__WeekReport' */'@/pages/athena/merchantProfile/tabs/board/WeekReport.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/columns/serviceDeliveryColumns",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__columns__serviceDeliveryColumns' */'@/pages/athena/merchantProfile/tabs/board/columns/serviceDeliveryColumns.js'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/columns/storeVisitColumns",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__columns__storeVisitColumns' */'@/pages/athena/merchantProfile/tabs/board/columns/storeVisitColumns.js'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/columns/tradeOrderColumns",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__columns__tradeOrderColumns' */'@/pages/athena/merchantProfile/tabs/board/columns/tradeOrderColumns.js'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/columns/visibleActivityColumns",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__columns__visibleActivityColumns' */'@/pages/athena/merchantProfile/tabs/board/columns/visibleActivityColumns.js'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/memberOps/ActivityPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__memberOps__ActivityPane' */'@/pages/athena/merchantProfile/tabs/board/memberOps/ActivityPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/memberOps/BehaviorPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__memberOps__BehaviorPane' */'@/pages/athena/merchantProfile/tabs/board/memberOps/BehaviorPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/memberOps/ClockInPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__memberOps__ClockInPane' */'@/pages/athena/merchantProfile/tabs/board/memberOps/ClockInPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/memberOps/OverviewPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__memberOps__OverviewPane' */'@/pages/athena/merchantProfile/tabs/board/memberOps/OverviewPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/board/memberOps/PortraitPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__board__memberOps__PortraitPane' */'@/pages/athena/merchantProfile/tabs/board/memberOps/PortraitPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/profileTab/FundPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__profileTab__FundPane' */'@/pages/athena/merchantProfile/tabs/profileTab/FundPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/profileTab/MerchantInfoPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__profileTab__MerchantInfoPane' */'@/pages/athena/merchantProfile/tabs/profileTab/MerchantInfoPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/profileTab/PowerPane",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__profileTab__PowerPane' */'@/pages/athena/merchantProfile/tabs/profileTab/PowerPane.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/tabs/profileTab/ServicePanes",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__tabs__profileTab__ServicePanes' */'@/pages/athena/merchantProfile/tabs/profileTab/ServicePanes.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/AnchorNav",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__AnchorNav' */'@/pages/athena/merchantProfile/ui/AnchorNav.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/CapsuleStat",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__CapsuleStat' */'@/pages/athena/merchantProfile/ui/CapsuleStat.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/ChartCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__ChartCard' */'@/pages/athena/merchantProfile/ui/ChartCard.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/DataTable",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__DataTable' */'@/pages/athena/merchantProfile/ui/DataTable.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/DistributionDonut",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__DistributionDonut' */'@/pages/athena/merchantProfile/ui/DistributionDonut.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/EmptyState",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__EmptyState' */'@/pages/athena/merchantProfile/ui/EmptyState.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/FilterChips",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__FilterChips' */'@/pages/athena/merchantProfile/ui/FilterChips.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/FilterDropdown",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__FilterDropdown' */'@/pages/athena/merchantProfile/ui/FilterDropdown.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/FunnelBars",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__FunnelBars' */'@/pages/athena/merchantProfile/ui/FunnelBars.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/InfoGrid",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__InfoGrid' */'@/pages/athena/merchantProfile/ui/InfoGrid.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/LazyMount",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__LazyMount' */'@/pages/athena/merchantProfile/ui/LazyMount.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/MemberList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__MemberList' */'@/pages/athena/merchantProfile/ui/MemberList.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/PosterWall",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__PosterWall' */'@/pages/athena/merchantProfile/ui/PosterWall.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/RankBars",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__RankBars' */'@/pages/athena/merchantProfile/ui/RankBars.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/SectionCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__SectionCard' */'@/pages/athena/merchantProfile/ui/SectionCard.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/StatCard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__StatCard' */'@/pages/athena/merchantProfile/ui/StatCard.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui/SubNav",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__SubNav' */'@/pages/athena/merchantProfile/ui/SubNav.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/merchantProfile/ui",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__merchantProfile__ui__index' */'@/pages/athena/merchantProfile/ui/index.js'), loading: LoadingComponent})
      },
      {
        "path": "/athena/noticeManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__noticeManagement__index' */'@/pages/athena/noticeManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/packManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__packManagement__index' */'@/pages/athena/packManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/pushManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__pushManagement__index' */'@/pages/athena/pushManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/athena/visibleSubmission",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__athena__visibleSubmission__index' */'@/pages/athena/visibleSubmission/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/authorityConfig/menuConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__authorityConfig__menuConfig__index' */'@/pages/authorityConfig/menuConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/authorityConfig/operationLog",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__authorityConfig__operationLog__index' */'@/pages/authorityConfig/operationLog/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/authorityConfig/role",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__authorityConfig__role__index' */'@/pages/authorityConfig/role/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/authorityConfig/roleSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__authorityConfig__roleSetting__index' */'@/pages/authorityConfig/roleSetting/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/canEat/canEatList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__canEat__canEatList__index' */'@/pages/canEat/canEatList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/channel/index",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__channel__index__index' */'@/pages/channel/index/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessBoard__index' */'@/pages/chart/businessBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/GMVdata",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__GMVdata' */'@/pages/chart/businessKeyIndicator/GMVdata.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/fundData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__fundData' */'@/pages/chart/businessKeyIndicator/fundData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__index' */'@/pages/chart/businessKeyIndicator/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/memberData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__memberData' */'@/pages/chart/businessKeyIndicator/memberData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/merchantData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__merchantData' */'@/pages/chart/businessKeyIndicator/merchantData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/merchantPageData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__merchantPageData' */'@/pages/chart/businessKeyIndicator/merchantPageData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/orderCountData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__orderCountData' */'@/pages/chart/businessKeyIndicator/orderCountData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/userOverviewData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__userOverviewData' */'@/pages/chart/businessKeyIndicator/userOverviewData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/businessKeyIndicator/userTrendData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__businessKeyIndicator__userTrendData' */'@/pages/chart/businessKeyIndicator/userTrendData.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/challengeRound",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__challengeRound__index' */'@/pages/chart/challengeRound/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/homeworkBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__homeworkBoard__index' */'@/pages/chart/homeworkBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/localRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__localRecord__index' */'@/pages/chart/localRecord/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/merchantData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__merchantData__index' */'@/pages/chart/merchantData/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/merchantDataDashboard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__merchantDataDashboard__index' */'@/pages/chart/merchantDataDashboard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/multiDimensionBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__multiDimensionBoard__index' */'@/pages/chart/multiDimensionBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/orderBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__orderBoard__index' */'@/pages/chart/orderBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/platformDataDashboard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__platformDataDashboard__index' */'@/pages/chart/platformDataDashboard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/privateVipBoard/LoadingBtn",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__privateVipBoard__LoadingBtn' */'@/pages/chart/privateVipBoard/LoadingBtn.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/privateVipBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__privateVipBoard__index' */'@/pages/chart/privateVipBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/qualityData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__qualityData__index' */'@/pages/chart/qualityData/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/targetBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__targetBoard__index' */'@/pages/chart/targetBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/tenantBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__tenantBoard__index' */'@/pages/chart/tenantBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/userBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__userBoard__index' */'@/pages/chart/userBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/userDataDashboard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__userDataDashboard__index' */'@/pages/chart/userDataDashboard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/vipBoard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__vipBoard__index' */'@/pages/chart/vipBoard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/chart/xplan",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__chart__xplan__index' */'@/pages/chart/xplan/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/classCalendar",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__classCalendar__index' */'@/pages/classCalendar/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachManage/classStatistics/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachManage__classStatistics__detail__index' */'@/pages/coachManage/classStatistics/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachManage/classStatistics",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachManage__classStatistics__index' */'@/pages/coachManage/classStatistics/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachManage/renewalRate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachManage__renewalRate__index' */'@/pages/coachManage/renewalRate/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachonline/addCoach",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachonline__addCoach__index' */'@/pages/coachonline/addCoach/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachonline/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachonline__edit__index' */'@/pages/coachonline/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/coachonline",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__coachonline__index' */'@/pages/coachonline/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/dashboard",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dashboard__index' */'@/pages/dashboard/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/greet/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__greet__edit' */'@/pages/greet/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/greet",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__greet__index' */'@/pages/greet/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/aiCourse/courseDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__aiCourse__courseDetail__index' */'@/pages/idongPush/aiCourse/courseDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/aiCourse/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__aiCourse__detail__index' */'@/pages/idongPush/aiCourse/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/aiCourse",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__aiCourse__index' */'@/pages/idongPush/aiCourse/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/courseImport",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__courseImport__index' */'@/pages/idongPush/courseImport/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/planCourse",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__planCourse__index' */'@/pages/idongPush/planCourse/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/idongPush/recordCourse",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__idongPush__recordCourse__index' */'@/pages/idongPush/recordCourse/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__index' */'@/pages/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/leave",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__leave__index' */'@/pages/leave/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/live/channel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__live__channel__index' */'@/pages/live/channel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/live/data",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__live__data' */'@/pages/live/data.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/live/liveContentLibrary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__live__liveContentLibrary__index' */'@/pages/live/liveContentLibrary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/login",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__login__index' */'@/pages/login/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/market/cdkey/add-cdkey-activity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__market__cdkey__add-cdkey-activity' */'@/pages/market/cdkey/add-cdkey-activity.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/market/cdkey/cdkey-store",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__market__cdkey__cdkey-store' */'@/pages/market/cdkey/cdkey-store.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/market/cdkey/download-record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__market__cdkey__download-record' */'@/pages/market/cdkey/download-record.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/market/cdkey",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__market__cdkey__index' */'@/pages/market/cdkey/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/market/cdkey/search-cdkey",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__market__cdkey__search-cdkey' */'@/pages/market/cdkey/search-cdkey.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanColumnManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanColumnManagement__index' */'@/pages/mediaManagement/TVXplanColumnManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanColumnManagement/projectOperation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanColumnManagement__projectOperation__index' */'@/pages/mediaManagement/TVXplanColumnManagement/projectOperation/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanColumnManagement/recommend",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanColumnManagement__recommend__index' */'@/pages/mediaManagement/TVXplanColumnManagement/recommend/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanCourseManagement/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanCourseManagement__edit__index' */'@/pages/mediaManagement/TVXplanCourseManagement/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanCourseManagement/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanCourseManagement__list__index' */'@/pages/mediaManagement/TVXplanCourseManagement/list/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanProjectManagement/addProject",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanProjectManagement__addProject__index' */'@/pages/mediaManagement/TVXplanProjectManagement/addProject/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/TVXplanProjectManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__TVXplanProjectManagement__index' */'@/pages/mediaManagement/TVXplanProjectManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/categoryManagement/courseDesc",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__categoryManagement__courseDesc__index' */'@/pages/mediaManagement/categoryManagement/courseDesc/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/categoryManagement/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__categoryManagement__edit__index' */'@/pages/mediaManagement/categoryManagement/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/categoryManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__categoryManagement__index' */'@/pages/mediaManagement/categoryManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/channelManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__channelManagement__index' */'@/pages/mediaManagement/channelManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/columnManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__columnManagement__index' */'@/pages/mediaManagement/columnManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/columnManagement/projectOperation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__columnManagement__projectOperation__index' */'@/pages/mediaManagement/columnManagement/projectOperation/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/columnManagement/recommend",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__columnManagement__recommend__index' */'@/pages/mediaManagement/columnManagement/recommend/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/contentManagement/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__contentManagement__edit__index' */'@/pages/mediaManagement/contentManagement/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/contentManagement/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__contentManagement__list__index' */'@/pages/mediaManagement/contentManagement/list/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/firstPageConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__firstPageConfig__index' */'@/pages/mediaManagement/firstPageConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/firstPageConfig/projectOperation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__firstPageConfig__projectOperation__index' */'@/pages/mediaManagement/firstPageConfig/projectOperation/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/hotAudioLibrary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__hotAudioLibrary__index' */'@/pages/mediaManagement/hotAudioLibrary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/introConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__introConfig__index' */'@/pages/mediaManagement/introConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/knowledgeBase",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__knowledgeBase__index' */'@/pages/mediaManagement/knowledgeBase/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/marketingConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__marketingConfig__index' */'@/pages/mediaManagement/marketingConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/projectManagement/addProject",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__projectManagement__addProject__index' */'@/pages/mediaManagement/projectManagement/addProject/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/projectManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__projectManagement__index' */'@/pages/mediaManagement/projectManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/punchPosterManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__punchPosterManagement__index' */'@/pages/mediaManagement/punchPosterManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/trainingCollege/column",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__trainingCollege__column__index' */'@/pages/mediaManagement/trainingCollege/column/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/trainingCollege/course",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__trainingCollege__course__index' */'@/pages/mediaManagement/trainingCollege/course/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/trainingCollege/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__trainingCollege__edit__index' */'@/pages/mediaManagement/trainingCollege/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/trainingCollege",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__trainingCollege__index' */'@/pages/mediaManagement/trainingCollege/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/trainingCollege/studyData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__trainingCollege__studyData__index' */'@/pages/mediaManagement/trainingCollege/studyData/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/mediaManagement/videoManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__mediaManagement__videoManagement__index' */'@/pages/mediaManagement/videoManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/billPeriod",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__billPeriod__index' */'@/pages/merchant/billPeriod/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/billPeriod/merchantList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__billPeriod__merchantList__index' */'@/pages/merchant/billPeriod/merchantList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/billPeriod/merchantOrderList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__billPeriod__merchantOrderList__index' */'@/pages/merchant/billPeriod/merchantOrderList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement/bindings",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__bindings__index' */'@/pages/merchant/brandManagement/bindings/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__edit__index' */'@/pages/merchant/brandManagement/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement/employees",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__employees__index' */'@/pages/merchant/brandManagement/employees/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement/import/ImportList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__import__ImportList' */'@/pages/merchant/brandManagement/import/ImportList.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement/import",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__import__index' */'@/pages/merchant/brandManagement/import/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/brandManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__brandManagement__index' */'@/pages/merchant/brandManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/copartner/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__copartner__edit__index' */'@/pages/merchant/copartner/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/copartner",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__copartner__index' */'@/pages/merchant/copartner/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/copartner/memberBindChange",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__copartner__memberBindChange__index' */'@/pages/merchant/copartner/memberBindChange/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/distribute",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__distribute__index' */'@/pages/merchant/distribute/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/distribution",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__distribution__index' */'@/pages/merchant/distribution/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/distributorManagement/bindings",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__distributorManagement__bindings__index' */'@/pages/merchant/distributorManagement/bindings/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/distributorManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__distributorManagement__index' */'@/pages/merchant/distributorManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/level/editLevel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__level__editLevel__index' */'@/pages/merchant/level/editLevel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/level",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__level__index' */'@/pages/merchant/level/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/manage/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__manage__edit__index' */'@/pages/merchant/manage/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/manage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__manage__index' */'@/pages/merchant/manage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/manage/member",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__manage__member__index' */'@/pages/merchant/manage/member/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/manage/memberBindChange",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__manage__memberBindChange__index' */'@/pages/merchant/manage/memberBindChange/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/merchantPrompt",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__merchantPrompt__index' */'@/pages/merchant/merchantPrompt/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary/customerClassDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__customerClassDetail__index' */'@/pages/merchant/partnerSalary/customerClassDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__index' */'@/pages/merchant/partnerSalary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary/partnerDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__partnerDetail__index' */'@/pages/merchant/partnerSalary/partnerDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary/partnerGMVDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__partnerGMVDetail__index' */'@/pages/merchant/partnerSalary/partnerGMVDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary/partnerList/download-record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__partnerList__download-record' */'@/pages/merchant/partnerSalary/partnerList/download-record.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/partnerSalary/partnerList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__partnerSalary__partnerList__index' */'@/pages/merchant/partnerSalary/partnerList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/performance",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__performance__index' */'@/pages/merchant/performance/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/performance/user",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__performance__user__index' */'@/pages/merchant/performance/user/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/statisticsChart",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__statisticsChart__index' */'@/pages/merchant/statisticsChart/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/statisticsDay",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__statisticsDay__index' */'@/pages/merchant/statisticsDay/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/statisticsMonth",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__statisticsMonth__index' */'@/pages/merchant/statisticsMonth/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/statisticsMonth/users",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__statisticsMonth__users__index' */'@/pages/merchant/statisticsMonth/users/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/traffictAllocationManage/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__traffictAllocationManage__detail__index' */'@/pages/merchant/traffictAllocationManage/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/merchant/traffictAllocationManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__merchant__traffictAllocationManage__index' */'@/pages/merchant/traffictAllocationManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/aiTel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__aiTel__index' */'@/pages/message/aiTel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/aliSms",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__aliSms__index' */'@/pages/message/aliSms/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/aliSmsHistory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__aliSmsHistory__index' */'@/pages/message/aliSmsHistory/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/appSetting",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__appSetting__index' */'@/pages/message/appSetting/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/appSetting/newTask",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__appSetting__newTask__index' */'@/pages/message/appSetting/newTask/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/coachTask/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__coachTask__edit__index' */'@/pages/message/coachTask/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/coachTask",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__coachTask__index' */'@/pages/message/coachTask/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/deeplink",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__deeplink__index' */'@/pages/message/deeplink/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/generateSopWithAI",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__generateSopWithAI__index' */'@/pages/message/generateSopWithAI/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/groupRpaManagement/download-record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__groupRpaManagement__download-record' */'@/pages/message/groupRpaManagement/download-record.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/groupRpaManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__groupRpaManagement__index' */'@/pages/message/groupRpaManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/h5Config/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__h5Config__edit' */'@/pages/message/h5Config/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/h5Config",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__h5Config__index' */'@/pages/message/h5Config/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/keywordHistory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__keywordHistory__index' */'@/pages/message/keywordHistory/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/keywordReply/editKeyword",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__keywordReply__editKeyword__index' */'@/pages/message/keywordReply/editKeyword/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/keywordReply",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__keywordReply__index' */'@/pages/message/keywordReply/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/littaMessageTemplate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__littaMessageTemplate__index' */'@/pages/message/littaMessageTemplate/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/messageRecord",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__messageRecord__index' */'@/pages/message/messageRecord/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/officialAccountConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__officialAccountConfig__index' */'@/pages/message/officialAccountConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/privateDomain",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__privateDomain__index' */'@/pages/message/privateDomain/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/prompt/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__prompt__edit__index' */'@/pages/message/prompt/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/prompt",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__prompt__index' */'@/pages/message/prompt/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/recharge/apiGoodsModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__recharge__apiGoodsModal' */'@/pages/message/recharge/apiGoodsModal.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/recharge",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__recharge__index' */'@/pages/message/recharge/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/rpaBlacklist",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__rpaBlacklist__index' */'@/pages/message/rpaBlacklist/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/rpaRobot",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__rpaRobot__index' */'@/pages/message/rpaRobot/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/rpaRoute",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__rpaRoute__index' */'@/pages/message/rpaRoute/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/sopTouch/editTouchEvent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__sopTouch__editTouchEvent__index' */'@/pages/message/sopTouch/editTouchEvent/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/sopTouch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__sopTouch__index' */'@/pages/message/sopTouch/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/sopTouch/touchEvent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__sopTouch__touchEvent__index' */'@/pages/message/sopTouch/touchEvent/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/template",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__template__index' */'@/pages/message/template/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/message/wxTagConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__message__wxTagConfig__index' */'@/pages/message/wxTagConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/middle",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__middle__index' */'@/pages/middle/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/okrData",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__okrData__index' */'@/pages/okrData/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/ExpiringSoon",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__ExpiringSoon__index' */'@/pages/operating/ExpiringSoon/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/bondManage/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__bondManage__detail__index' */'@/pages/operating/bondManage/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/bondManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__bondManage__index' */'@/pages/operating/bondManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/classScore",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__classScore__index' */'@/pages/operating/classScore/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary/classDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__classDetail__index' */'@/pages/operating/coachSalary/classDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary/coachList/download-record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__coachList__download-record' */'@/pages/operating/coachSalary/coachList/download-record.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary/coachList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__coachList__index' */'@/pages/operating/coachSalary/coachList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary/customerClassDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__customerClassDetail__index' */'@/pages/operating/coachSalary/customerClassDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__index' */'@/pages/operating/coachSalary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coachSalary/merchantList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coachSalary__merchantList__index' */'@/pages/operating/coachSalary/merchantList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coupon/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coupon__edit__index' */'@/pages/operating/coupon/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coupon",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coupon__index' */'@/pages/operating/coupon/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/coupon/record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__coupon__record__index' */'@/pages/operating/coupon/record/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/curriculum",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__curriculum__index' */'@/pages/operating/curriculum/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/customerAccount/add",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__customerAccount__add__index' */'@/pages/operating/customerAccount/add/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/customerAccount",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__customerAccount__index' */'@/pages/operating/customerAccount/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/customerService",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__customerService__index' */'@/pages/operating/customerService/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/distribution",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__distribution__index' */'@/pages/operating/distribution/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/distribution/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__distribution__list__index' */'@/pages/operating/distribution/list/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/external-product/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__external-product__edit__index' */'@/pages/operating/external-product/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/external-product",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__external-product__index' */'@/pages/operating/external-product/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/family",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__family__index' */'@/pages/operating/family/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/family/list",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__family__list' */'@/pages/operating/family/list.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/firstLoss",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__firstLoss__index' */'@/pages/operating/firstLoss/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/followup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__followup__index' */'@/pages/operating/followup/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/goodsMerchantBind",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__goodsMerchantBind__index' */'@/pages/operating/goodsMerchantBind/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/group-rules/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__group-rules__edit' */'@/pages/operating/group-rules/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/group-rules",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__group-rules__index' */'@/pages/operating/group-rules/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/merchant",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__merchant__index' */'@/pages/operating/merchant/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/notBegin",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__notBegin__index' */'@/pages/operating/notBegin/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/offlineMaterial/generatingPoll",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__offlineMaterial__generatingPoll' */'@/pages/operating/offlineMaterial/generatingPoll.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/offlineMaterial",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__offlineMaterial__index' */'@/pages/operating/offlineMaterial/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/offlineMaterial/records/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__offlineMaterial__records__detail__index' */'@/pages/operating/offlineMaterial/records/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/offlineMaterial/records",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__offlineMaterial__records__index' */'@/pages/operating/offlineMaterial/records/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/offlineMaterial/zipNotice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__offlineMaterial__zipNotice' */'@/pages/operating/offlineMaterial/zipNotice.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/order",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__order__index' */'@/pages/operating/order/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/outorder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__outorder__index' */'@/pages/operating/outorder/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/package-goods/add",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__package-goods__add__index' */'@/pages/operating/package-goods/add/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/package-goods",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__package-goods__index' */'@/pages/operating/package-goods/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/physical-goods/add-goods",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__physical-goods__add-goods__index' */'@/pages/operating/physical-goods/add-goods/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/physical-goods",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__physical-goods__index' */'@/pages/operating/physical-goods/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/promotionActivity/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__promotionActivity__edit__index' */'@/pages/operating/promotionActivity/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/promotionActivity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__promotionActivity__index' */'@/pages/operating/promotionActivity/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/renewal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__renewal__index' */'@/pages/operating/renewal/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/rewardActivity/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__rewardActivity__edit__index' */'@/pages/operating/rewardActivity/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/rewardActivity",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__rewardActivity__index' */'@/pages/operating/rewardActivity/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/riskAudit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__riskAudit__index' */'@/pages/operating/riskAudit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/salaryRecords",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__salaryRecords__index' */'@/pages/operating/salaryRecords/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/salaryRecords/merchantDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__salaryRecords__merchantDetail__index' */'@/pages/operating/salaryRecords/merchantDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/salaryRecords/partnerDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__salaryRecords__partnerDetail__index' */'@/pages/operating/salaryRecords/partnerDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/scheduling/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__scheduling__edit' */'@/pages/operating/scheduling/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/scheduling",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__scheduling__index' */'@/pages/operating/scheduling/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/scheduling/statistic",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__scheduling__statistic' */'@/pages/operating/scheduling/statistic.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/scoreSchedule/add",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__scoreSchedule__add__index' */'@/pages/operating/scoreSchedule/add/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/scoreSchedule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__scoreSchedule__index' */'@/pages/operating/scoreSchedule/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/thirdGoodsSync",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__thirdGoodsSync__index' */'@/pages/operating/thirdGoodsSync/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/vip-goods/add-vip-goods",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__vip-goods__add-vip-goods__index' */'@/pages/operating/vip-goods/add-vip-goods/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/vip-goods",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__vip-goods__index' */'@/pages/operating/vip-goods/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/operating/whitelist",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__operating__whitelist__index' */'@/pages/operating/whitelist/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/period/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__period__detail__index' */'@/pages/plan/period/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/period/detail/trainClass",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__period__detail__trainClass__index' */'@/pages/plan/period/detail/trainClass/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/period/detail/videoClass",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__period__detail__videoClass__index' */'@/pages/plan/period/detail/videoClass/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/period",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__period__index' */'@/pages/plan/period/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/voice/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__voice__edit__index' */'@/pages/plan/voice/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/plan/voice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__plan__voice__index' */'@/pages/plan/voice/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/potentialUser",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__potentialUser__index' */'@/pages/potentialUser/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/potentialUser/tagGroup",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__potentialUser__tagGroup__index' */'@/pages/potentialUser/tagGroup/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/prescription/planLibrary/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__prescription__planLibrary__detail__index' */'@/pages/prescription/planLibrary/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/prescription/planLibrary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__prescription__planLibrary__index' */'@/pages/prescription/planLibrary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/prescription/rule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__prescription__rule__index' */'@/pages/prescription/rule/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/channel-config/addChannel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__channel-config__addChannel__index' */'@/pages/promotion/channel-config/addChannel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/channel-config/checkChannel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__channel-config__checkChannel__index' */'@/pages/promotion/channel-config/checkChannel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/channel-config/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__channel-config__edit__index' */'@/pages/promotion/channel-config/edit/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/channel-config/editChannel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__channel-config__editChannel__index' */'@/pages/promotion/channel-config/editChannel/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/channel-config",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__channel-config__index' */'@/pages/promotion/channel-config/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/consult/add",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__consult__add__index' */'@/pages/promotion/consult/add/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/consult/check",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__consult__check__index' */'@/pages/promotion/consult/check/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/consult",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__consult__index' */'@/pages/promotion/consult/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__detail__index' */'@/pages/promotion/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/distributionManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__distributionManagement__index' */'@/pages/promotion/distributionManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__index' */'@/pages/promotion/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/moduleManage/ConfigArea",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__moduleManage__ConfigArea' */'@/pages/promotion/moduleManage/ConfigArea.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/moduleManage/PreviewArea",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__moduleManage__PreviewArea' */'@/pages/promotion/moduleManage/PreviewArea.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/moduleManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__moduleManage__index' */'@/pages/promotion/moduleManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/promotion/rightActivateModeView",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__promotion__rightActivateModeView__index' */'@/pages/promotion/rightActivateModeView/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/ptdevice",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ptdevice__index' */'@/pages/ptdevice/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/aliAccountManage/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__aliAccountManage__detail__index' */'@/pages/settlement/aliAccountManage/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/aliAccountManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__aliAccountManage__index' */'@/pages/settlement/aliAccountManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/aliAccountManage/transferDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__aliAccountManage__transferDetail__index' */'@/pages/settlement/aliAccountManage/transferDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/aliSettlementManage/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__aliSettlementManage__detail__index' */'@/pages/settlement/aliSettlementManage/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/aliSettlementManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__aliSettlementManage__index' */'@/pages/settlement/aliSettlementManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlement/classDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlement__classDetail__index' */'@/pages/settlement/merchantSettlement/classDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlement/coachList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlement__coachList__index' */'@/pages/settlement/merchantSettlement/coachList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlement/customerClassDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlement__customerClassDetail__index' */'@/pages/settlement/merchantSettlement/customerClassDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlement__index' */'@/pages/settlement/merchantSettlement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlement/merchantList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlement__merchantList__index' */'@/pages/settlement/merchantSettlement/merchantList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome/cashInTransitDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__cashInTransitDetail__index' */'@/pages/settlement/merchantSettlementIncome/cashInTransitDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome/employeeSettlement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__employeeSettlement__index' */'@/pages/settlement/merchantSettlementIncome/employeeSettlement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome/employeeSettlementDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__employeeSettlementDetail__index' */'@/pages/settlement/merchantSettlementIncome/employeeSettlementDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome/expenditureDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__expenditureDetail__index' */'@/pages/settlement/merchantSettlementIncome/expenditureDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__index' */'@/pages/settlement/merchantSettlementIncome/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/settlement/merchantSettlementIncome/withdrawalDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__settlement__merchantSettlementIncome__withdrawalDetail__index' */'@/pages/settlement/merchantSettlementIncome/withdrawalDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/stockrule/add",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__stockrule__add__index' */'@/pages/stockrule/add/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/stockrule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__stockrule__index' */'@/pages/stockrule/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/stockrule/update",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__stockrule__update__index' */'@/pages/stockrule/update/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/systemConfig/addressBook",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemConfig__addressBook__index' */'@/pages/systemConfig/addressBook/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/systemConfig/metsConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__systemConfig__metsConfig__index' */'@/pages/systemConfig/metsConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionConfig/AiConfigCandidateReview",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionConfig__AiConfigCandidateReview' */'@/pages/technical/actionConfig/AiConfigCandidateReview.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionConfig/MotionConfigAiGenerator",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionConfig__MotionConfigAiGenerator' */'@/pages/technical/actionConfig/MotionConfigAiGenerator.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionConfig/MotionConfigVisualBuilder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionConfig__MotionConfigVisualBuilder' */'@/pages/technical/actionConfig/MotionConfigVisualBuilder.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionConfig__index' */'@/pages/technical/actionConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionDiagnosis/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionDiagnosis__detail' */'@/pages/technical/actionDiagnosis/detail.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/actionDiagnosis",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__actionDiagnosis__index' */'@/pages/technical/actionDiagnosis/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/agent",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__agent__index' */'@/pages/technical/agent/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/androidAuditSwitch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__androidAuditSwitch__index' */'@/pages/technical/androidAuditSwitch/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/appVersionControl",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__appVersionControl__index' */'@/pages/technical/appVersionControl/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/capabilityAccount",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__capabilityAccount__index' */'@/pages/technical/capabilityAccount/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/capabilityConfig/CapabilityConfigAiGenerator",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__capabilityConfig__CapabilityConfigAiGenerator' */'@/pages/technical/capabilityConfig/CapabilityConfigAiGenerator.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/capabilityConfig/CapabilityConfigVisualBuilder",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__capabilityConfig__CapabilityConfigVisualBuilder' */'@/pages/technical/capabilityConfig/CapabilityConfigVisualBuilder.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/capabilityConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__capabilityConfig__index' */'@/pages/technical/capabilityConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/cardTemplateManager/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__cardTemplateManager__edit' */'@/pages/technical/cardTemplateManager/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/cardTemplateManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__cardTemplateManager__index' */'@/pages/technical/cardTemplateManager/index.jsx'), loading: LoadingComponent}),
        "propTypes": {},
        "defaultProps": {
          "location": {
            "query": {}
          }
        }
      },
      {
        "path": "/technical/classPlayback",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__classPlayback__index' */'@/pages/technical/classPlayback/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/degradationManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__degradationManager__index' */'@/pages/technical/degradationManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/degradationUser",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__degradationUser__index' */'@/pages/technical/degradationUser/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/devicePerformance",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__devicePerformance__index' */'@/pages/technical/devicePerformance/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/equipmentLibrary/edit",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__equipmentLibrary__edit' */'@/pages/technical/equipmentLibrary/edit.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/equipmentLibrary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__equipmentLibrary__index' */'@/pages/technical/equipmentLibrary/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/equipmentLibrary/storeEquipment",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__equipmentLibrary__storeEquipment__index' */'@/pages/technical/equipmentLibrary/storeEquipment/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/eventTracking",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__eventTracking__index' */'@/pages/technical/eventTracking/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase/dris",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__dris__index' */'@/pages/technical/foodDatabase/dris/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase/foodDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__foodDetail__index' */'@/pages/technical/foodDatabase/foodDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase/foodForm",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__foodForm__index' */'@/pages/technical/foodDatabase/foodForm/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase/foodInsert",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__foodInsert__index' */'@/pages/technical/foodDatabase/foodInsert/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase/foodList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__foodList__index' */'@/pages/technical/foodDatabase/foodList/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/foodDatabase",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__foodDatabase__index' */'@/pages/technical/foodDatabase/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/gptConfig",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__gptConfig__index' */'@/pages/technical/gptConfig/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/h5PackageManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__h5PackageManager__index' */'@/pages/technical/h5PackageManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/htmlTemplateBusinessManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__htmlTemplateBusinessManager__index' */'@/pages/technical/htmlTemplateBusinessManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/htmlTemplateManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__htmlTemplateManager__index' */'@/pages/technical/htmlTemplateManager/index.jsx'), loading: LoadingComponent}),
        "propTypes": {},
        "defaultProps": {
          "location": {
            "query": {}
          }
        }
      },
      {
        "path": "/technical/iosAuditSwitch",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__iosAuditSwitch__index' */'@/pages/technical/iosAuditSwitch/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/knowledgeRuleManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__knowledgeRuleManager__index' */'@/pages/technical/knowledgeRuleManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/lpaasPublish/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__lpaasPublish__detail' */'@/pages/technical/lpaasPublish/detail.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/lpaasPublish",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__lpaasPublish__index' */'@/pages/technical/lpaasPublish/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/ActionProfileSummary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__ActionProfileSummary' */'@/pages/technical/memberTrainingWorkspace/ActionProfileSummary.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CommunicationProcessingPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CommunicationProcessingPanel' */'@/pages/technical/memberTrainingWorkspace/CommunicationProcessingPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CommunicationWindowRetryButton",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CommunicationWindowRetryButton' */'@/pages/technical/memberTrainingWorkspace/CommunicationWindowRetryButton.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CourseEvaluationRetryButton",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CourseEvaluationRetryButton' */'@/pages/technical/memberTrainingWorkspace/CourseEvaluationRetryButton.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CourseProcessingPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CourseProcessingPanel' */'@/pages/technical/memberTrainingWorkspace/CourseProcessingPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanAnalysisPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanAnalysisPanel' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanAnalysisPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanCourse",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanCourse' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanCourse.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanHistory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanHistory' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanHistory.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanPanel' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanSchedule",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanSchedule' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanSchedule.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/CurrentPlanTiming",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__CurrentPlanTiming' */'@/pages/technical/memberTrainingWorkspace/CurrentPlanTiming.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/FactSyncProcessingSummary",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__FactSyncProcessingSummary' */'@/pages/technical/memberTrainingWorkspace/FactSyncProcessingSummary.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/FactSyncRetryButton",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__FactSyncRetryButton' */'@/pages/technical/memberTrainingWorkspace/FactSyncRetryButton.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/GoalInsightPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__GoalInsightPanel' */'@/pages/technical/memberTrainingWorkspace/GoalInsightPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/MemberTagEvidence",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__MemberTagEvidence' */'@/pages/technical/memberTrainingWorkspace/MemberTagEvidence.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/MemberTagPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__MemberTagPanel' */'@/pages/technical/memberTrainingWorkspace/MemberTagPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/MemberTagReviewPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__MemberTagReviewPanel' */'@/pages/technical/memberTrainingWorkspace/MemberTagReviewPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/MemberTrainingArchiveList",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__MemberTrainingArchiveList' */'@/pages/technical/memberTrainingWorkspace/MemberTrainingArchiveList.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/SimpleWorkspace",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__SimpleWorkspace' */'@/pages/technical/memberTrainingWorkspace/SimpleWorkspace.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/SimpleWorkspaceColumns",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__SimpleWorkspaceColumns' */'@/pages/technical/memberTrainingWorkspace/SimpleWorkspaceColumns.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/SimpleWorkspaceDrawers",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__SimpleWorkspaceDrawers' */'@/pages/technical/memberTrainingWorkspace/SimpleWorkspaceDrawers.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/SimpleWorkspaceOverview",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__SimpleWorkspaceOverview' */'@/pages/technical/memberTrainingWorkspace/SimpleWorkspaceOverview.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/SimpleWorkspaceTabs",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__SimpleWorkspaceTabs' */'@/pages/technical/memberTrainingWorkspace/SimpleWorkspaceTabs.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/TrainingAdvicePanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__TrainingAdvicePanel' */'@/pages/technical/memberTrainingWorkspace/TrainingAdvicePanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/TrainingPulsePanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__TrainingPulsePanel' */'@/pages/technical/memberTrainingWorkspace/TrainingPulsePanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/WorkspaceNavigation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__WorkspaceNavigation' */'@/pages/technical/memberTrainingWorkspace/WorkspaceNavigation.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/actionDetail/ActionInterpretationPanel",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__actionDetail__ActionInterpretationPanel' */'@/pages/technical/memberTrainingWorkspace/actionDetail/ActionInterpretationPanel.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/actionDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__actionDetail__index' */'@/pages/technical/memberTrainingWorkspace/actionDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/courseDetail/CourseStructure",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__courseDetail__CourseStructure' */'@/pages/technical/memberTrainingWorkspace/courseDetail/CourseStructure.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace/courseDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__courseDetail__index' */'@/pages/technical/memberTrainingWorkspace/courseDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/memberTrainingWorkspace",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__memberTrainingWorkspace__index' */'@/pages/technical/memberTrainingWorkspace/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/patrol",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__patrol__index' */'@/pages/technical/patrol/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/powerManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__powerManager__index' */'@/pages/technical/powerManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/powerMoveCourseEvaluation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__powerMoveCourseEvaluation__index' */'@/pages/technical/powerMoveCourseEvaluation/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/powerMoveEvaluation",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__powerMoveEvaluation__index' */'@/pages/technical/powerMoveEvaluation/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/powerMoveWhitelist",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__powerMoveWhitelist__index' */'@/pages/technical/powerMoveWhitelist/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/roomDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__roomDetail__index' */'@/pages/technical/roomDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/routerPathManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__routerPathManager__index' */'@/pages/technical/routerPathManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/routerPathManager/store/RouterPathContext",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__routerPathManager__store__RouterPathContext' */'@/pages/technical/routerPathManager/store/RouterPathContext.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/sdkClient",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__sdkClient__index' */'@/pages/technical/sdkClient/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/signal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__signal__index' */'@/pages/technical/signal/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/siteMenuManagement",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__siteMenuManagement__index' */'@/pages/technical/siteMenuManagement/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/standardCourseGray",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__standardCourseGray__index' */'@/pages/technical/standardCourseGray/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/storeCalibration/AdoptionHistory",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__storeCalibration__AdoptionHistory' */'@/pages/technical/storeCalibration/AdoptionHistory.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/storeCalibration/BatchDetailModal",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__storeCalibration__BatchDetailModal' */'@/pages/technical/storeCalibration/BatchDetailModal.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/storeCalibration",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__storeCalibration__index' */'@/pages/technical/storeCalibration/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/storeCoordinatesUpdate",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__storeCoordinatesUpdate__index' */'@/pages/technical/storeCoordinatesUpdate/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/uniPackageManager",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__uniPackageManager__index' */'@/pages/technical/uniPackageManager/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/uploadResources",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__uploadResources__index' */'@/pages/technical/uploadResources/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/technical/xplanVkManage",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__technical__xplanVkManage__index' */'@/pages/technical/xplanVkManage/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/thirdparty",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__thirdparty__index' */'@/pages/thirdparty/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/changes",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__changes__index' */'@/pages/user/changes/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/detail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__detail__index' */'@/pages/user/detail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/distribute",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__distribute__index' */'@/pages/user/distribute/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/index",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__index__index' */'@/pages/user/index/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/record",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__record__index' */'@/pages/user/record/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/user/treehole",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__treehole__index' */'@/pages/user/treehole/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/userHealthIndex/sportIndex",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__userHealthIndex__sportIndex__index' */'@/pages/userHealthIndex/sportIndex/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/userRights",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__userRights__index' */'@/pages/userRights/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/vitalityGo/blocklist",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__vitalityGo__blocklist__index' */'@/pages/vitalityGo/blocklist/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/vitalityGo/storeDetail",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__vitalityGo__storeDetail__index' */'@/pages/vitalityGo/storeDetail/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/vitalityGo/storeMap",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__vitalityGo__storeMap__index' */'@/pages/vitalityGo/storeMap/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/weChat",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__weChat__index' */'@/pages/weChat/index.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/weChat/planH5",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__weChat__planH5' */'@/pages/weChat/planH5.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/weChat/reportBox",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__weChat__reportBox' */'@/pages/weChat/reportBox.jsx'), loading: LoadingComponent})
      },
      {
        "path": "/weChat/reportH5",
        "exact": true,
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__weChat__reportH5' */'@/pages/weChat/reportH5.jsx'), loading: LoadingComponent})
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'@/pages/404.jsx'), loading: LoadingComponent})
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
